import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getReplenishmentReportCsv = (params) => {
    return axios.get(`${backendHost}/api/admin/replenishment/report/csv`, {params});
};

export {
    getReplenishmentReportCsv
}